import { CHALLENGE_SUGGESTION_COLUMNS } from "./challenge-suggestions-column";
import DataTable from "../../../components/common/data-table/data-table";
import ChallengeSuggestionForm from "./challenge-suggestion-form";
import { ChallengeSuggestionSchema } from "./challenge-suggestion-schema";

interface ChallengeSuggestionProps {}

const ChallengeSuggestion: React.FC<ChallengeSuggestionProps> = () => {
  return (
    <div>
      <DataTable
        tableName="Challenge Suggestions"
        parentTableName="Overview"
        deleteTitle="Challenge Suggestion"
        mainCol="title"
        tableCols={CHALLENGE_SUGGESTION_COLUMNS}
        getAllLink="/api/admin/challenges?user_id[isNull]=false" //TODO add "api" to base rout //BUG this param is valied in syntax
        deleteRowLink="/api/admin/challenges" //TODO add "api" to base rout
        getItemLink="/api/admin/challenges" //TODO add "api" to base rout
        updateItemLink="/api/admin/challenges" //TODO add "api" to base rout
        FormContent={ChallengeSuggestionForm}
        formSchema={ChallengeSuggestionSchema}
        hasEdit={true}
        hasDelete={false}
        formDataMapper={(data: any) => {
          return {
            ...data,
            status: data?.approvalStatus?.value,
            // type: data?.type.label,
            // username: data?.user?.fullName,
            // mediaType: data?.mediaType?.label,
          };
        }}
        formSubmitMapper={(data: any) => {
          return {
            approvalStatus: data?.status,
            // published: data?.published,
          };
        }}
      />
    </div>
  );
};

export default ChallengeSuggestion;
